/**
 * Parses pipe-separated filter values into array, filtering out empty strings.
 * @example parseFilterValues("CODE1|CODE2") // ["CODE1", "CODE2"]
 */
export function parseFilterValues(value: string): string[] {
    return value ? value.split('|').filter(v => v.trim() !== '') : [];
}

/**
 * Joins filter values array into pipe-separated string.
 * @example joinFilterValues(["CODE1", "CODE2"]) // "CODE1|CODE2"
 */
export function joinFilterValues(values: string[]): string {
    return values.join('|');
}
